"use strict";
angular.module("relateManuscriptsModule", []).
directive("relateManuscripts", ['$timeout', '$stateParams', function($timeout, $stateParams) {
    return {
        replace: true,
        restrict: 'E',
        scope: {
            curSelected: '=',
            relateListPage: '=',
            relateManuList: '=',
            callback: '&'
        },
        templateUrl: './planningCenter/hotFocus/directive/relateManuscripts/relateManuscripts_tpl.html',
        link: function(scope, $elem, $attrs) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
            }

            /**
             * [moveLeftManus 左移]
             * @return {[type]} [description]
             */
            scope.moveLeftManus = function() {
                if ((scope.relateListPage.pageno - 1) <= 0) {
                    return;
                }
                scope.relateListPage.pageno--;
                $timeout(function() {
                    scope.callback();
                });
            }

            /**
             * [moveRightManus 右移]
             * @return {[type]} [description]
             */
            scope.moveRightManus = function() {
                if (!scope.relateListPage.totalpages || (scope.relateListPage.pageno + 1) > scope.relateListPage.totalpages) {
                    return;
                }
                scope.relateListPage.pageno++;
                $timeout(function() {
                    scope.callback();
                });
            }

        }
    };
}]);